import React from 'react';
const PersonalizedContainerFC = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, "PersonalizedContainerFC")));
};
export default PersonalizedContainerFC;
//# sourceMappingURL=PersonalizedContainerFC.js.map